import {
    getAuthenticationLink,
    authenTiktokAccount
} from '@/services/atosa-tiktok-ads/tiktok-account'
import { getBusinessCenters } from '@/services/atosa-tiktok-ads/business-center'
import {
    createBCOnBoarding,
    createAdAccountOnBoarding
} from '@/services/atosa-tiktok-ads/on-boarding'
import { getTiktokAccounts } from '@/services/atosa-tiktok-ads/tiktok-account'

export default {
    data() {
        return {
            max_bc_number: 20,
            selected_tiktok_business: null,
            business_centers: [],
            active_collapse: 1,
            is_creating_bc: false,
            form_create_bc: {
                values: {
                    name: '',
                    timezone: 'Asia/Ho_Chi_Minh'
                },
                rules: {
                    name: [
                        {
                            required: true,
                            message: this.$t('input.rule.not_empty'),
                            trigger: 'blur'
                        }
                    ],
                    timezone: [
                        {
                            required: true,
                            message: this.$t('input.rule.not_empty'),
                            trigger: 'change'
                        }
                    ]
                }
            },
            form_create_ads_account: {
                values: {
                    target_bc_id: '',
                    advertiser_info: {
                        currency: this.p__default_currency_app,
                        name: '',
                        timezone: 'Asia/Ho_Chi_Minh'
                    },
                    billing_info: {
                        address: '',
                        vat: 'VAT'
                    },
                    customer_info: {
                        company: 'ATOSA',
                        industry: '292703',
                        registered_area: 'VN'
                    },
                    qualification_info: {
                        promotion_link: 'https://atosa.asia/'
                    }
                },
                rules: {
                    target_bc_id: [
                        {
                            required: true,
                            message: this.$t('input.rule.not_empty'),
                            trigger: 'blur'
                        }
                    ],
                    advertiser_info: {
                        currency: [
                            {
                                required: true,
                                message: this.$t('input.rule.not_empty'),
                                trigger: 'blur'
                            }
                        ],
                        name: [
                            {
                                required: true,
                                message: this.$t('input.rule.not_empty'),
                                trigger: 'blur'
                            }
                        ],
                        timezone: [
                            {
                                required: true,
                                message: this.$t('input.rule.not_empty'),
                                trigger: 'blur'
                            }
                        ]
                    },
                    qualification_info: {
                        promotion_link: [
                            {
                                required: true,
                                message: this.$t('input.rule.not_empty'),
                                trigger: 'blur'
                            }
                        ]
                    },
                    customer_info: {
                        company: [
                            {
                                required: true,
                                message: this.$t('input.rule.not_empty'),
                                trigger: 'blur'
                            }
                        ]
                    }
                }
            }
        }
    },

    computed: {
        tiktok_businesses() {
            return this.$store.getters.tiktokBusiness.s__tiktok_businesses
        },

        s__website() {
            return this.$store.getters.app.s__website
        }
    },

    watch: {
        s__website() {
            this.form_create_ads_account.values.qualification_info.promotion_link =
                this.s__website
        },

        is_creating_bc() {
            this.$refs['form_create_bc']?.resetFields()
        },

        active_collapse() {
            this.$refs['form_create_bc']?.resetFields()

            const temp_target_bc_id =
                this.form_create_ads_account.values.target_bc_id
            this.$refs['form_create_ads_account']?.resetFields()
            this.form_create_ads_account.values.target_bc_id = temp_target_bc_id
        }
    },

    async mounted() {
        const auth_code = this.$route.query.auth_code
        if (auth_code) {
            await this.authenTtAccount(auth_code)
        }

        const { tiktok_account_id, bc_id } = this.$route.query
        if (tiktok_account_id) {
            const tiktok_account_found = this.tiktok_businesses.find(
                (i) => i.id === tiktok_account_id
            )
            if (tiktok_account_found) {
                this.active_collapse = 2
                await this.handleSelectTiktokAccount(tiktok_account_found)

                if (bc_id) {
                    this.active_collapse = 3
                    await this.handleSelectedBC(bc_id)
                }

                const query = Object.assign({}, this.$route.query)
                delete query.tiktok_account_id
                delete query.bc_id
                this.$router.replace({ query })
            }
        }
    },

    methods: {
        async handleConnectTiktokAccount() {
            const response = await getAuthenticationLink()
            window.open(response.data.link, '_self')
        },

        async fetchListTiktokAccounts() {
            const response = await getTiktokAccounts()

            if (response.code === 0 && response.data.list.length > 0) {
                await this.$store.dispatch(
                    'tiktokBusiness/s__setTiktokBusinesses',
                    response.data.list
                )
            } else {
                await this.$store.dispatch(
                    'tiktokBusiness/s__setTiktokBusinesses',
                    []
                )
            }
        },

        async authenTtAccount(auth_code) {
            try {
                const response = await authenTiktokAccount({
                    auth_code
                })

                if (response.code === 0) {
                    await this.fetchListTiktokAccounts()
                }
            } catch (error) {
                setTimeout(() => {
                    window.open(
                        `${this.p__group_route.ads_manager}/${this.p__route.tiktok_business}/connect`,
                        '_self'
                    )
                }, 1500)
                console.error(error)
            }
        },

        submitFormCreateBC() {
            this.$refs['form_create_bc'].validate((valid) => {
                if (valid) {
                    this.handleCreateBC().catch(console.error)
                }
            })
        },

        submitFormCreateAdsAccount() {
            this.$refs['form_create_ads_account'].validate((valid) => {
                if (valid) {
                    this.handleCreateAdsAccount()
                        // .then(() => this.$router.push('/ads-manager/advertiser-account'))
                        .then(() =>
                            this.$router.push(
                                `${this.p__group_route.ads_manager}/${this.p__route.payment}`
                            )
                        )
                        .catch(console.error)
                }
            })
        },

        async handleCreateAdsAccount() {
            if (
                !this.selected_tiktok_business ||
                !this.selected_tiktok_business.id
            ) {
                return
            }

            this.m__loading = true

            try {
                const response = await createAdAccountOnBoarding(
                    this.selected_tiktok_business.id,
                    this.form_create_ads_account.values
                )

                if (response.code === 0) {
                    this.m__loading = false
                    this.p__showNotify(
                        'success',
                        this.$t(
                            'page.connect_tiktok_account.message_connect_ads_account_success'
                        )
                    )
                }
            } catch (error) {
                this.m__loading = false
                // this.p__showNotify(
                //     'error',
                //     this.$t(
                //         'page.connect_tiktok_account.message_connect_ads_account_error'
                //     )
                // )
            }
        },

        async handleCreateBC() {
            if (
                !this.selected_tiktok_business ||
                !this.selected_tiktok_business.id
            ) {
                return
            }

            this.m__loading = true

            try {
                const response = await createBCOnBoarding(
                    this.selected_tiktok_business.id,
                    {
                        bc_name: this.form_create_bc.values.name,
                        timezone: this.form_create_bc.values.timezone
                    }
                )

                if (response.code === 0) {
                    await this.getBCByAccount()
                    this.is_creating_bc = false
                }
            } catch (error) {
                console.error(error)
            }

            this.m__loading = false
        },

        async getBCByAccount() {
            if (
                !this.selected_tiktok_business ||
                !this.selected_tiktok_business.id
            ) {
                return
            }

            const response = await getBusinessCenters(
                this.selected_tiktok_business.id
            )

            if (response.code === 0) {
                this.business_centers = response.data
            }
        },

        handleSelectedBC(bc_id) {
            this.form_create_ads_account.values.target_bc_id = bc_id
            this.active_collapse = 3
        },

        async handleSelectTiktokAccount(account) {
            this.selected_tiktok_business = account

            await this.getBCByAccount()

            this.is_creating_bc = this.business_centers.length === 0

            this.active_collapse = 2
        }
    }
}
